module.exports = __webpack_public_path__ + "static/img/pic_changs@2x.8f5538af.png";